import groupHttp from './groupHttp';

const getPermissionGroups = (context) => {
  return new Promise((resolve, reject) => {
    groupHttp.getGroups(context)
      .then(response => {
        resolve(formatToPermission(response.body));
      }, error => {
        reject(error);
      });
  });
};

const getGroups = (context) => {
  return new Promise((resolve, reject) => {
    groupHttp.getGroups(context)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const createGroup = (context, group) => {
  return new Promise((resolve, reject) => {
    groupHttp.createGroup(context, group)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const updateGroup = (context, group) => {
  return new Promise((resolve, reject) => {
    groupHttp.updateGroup(context, group)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const deleteGroup = (context, groupId) => {
  return new Promise((resolve, reject) => {
    groupHttp.deleteGroup(context, groupId)
      .then(() => {
        resolve();
      }, error => {
        reject(error);
      });
  });
};

const addUserIntoGroup = (constext, groupId, userId) => {
  return new Promise((resolve, reject) => {
    groupHttp.addUserIntoGroup(constext, groupId, userId).then(() => {
      resolve();
    }, error => {
      reject(error);
    });
  });
};

const removeUserFromGroup = (constext, groupId, userId) => {
  return new Promise((resolve, reject) => {
    groupHttp.removeUserFromGroup(constext, groupId, userId).then(() => {
      resolve();
    }, error => {
      reject(error);
    });
  });
};

const getUsersOfGroup = (context, groupId) => {
  return new Promise((resolve, reject) => {
    groupHttp.getUsersOfGroup(context, groupId).then((response) => {
      resolve(response.body);
    }, error => {
      reject(error);
    });
  });
};

const getPermissionsOfGroup = (context, groupId) => {
  return new Promise((resolve, reject) => {
    groupHttp.getPermissionsOfGroup(context, groupId).then((response) => {
      resolve(response.body);
    }, error => {
      reject(error);
    });
  });
};

const setPermissionsOfGroup = (context, groupId, permission) => {
  return new Promise((resolve, reject) => {
    groupHttp.setPermissionsOfGroup(context, groupId, permission).then(() => {
      resolve();
    }, error => {
      reject(error);
    });
  });
};

const formatToPermission = (groups) => {
  return groups.map(group => ({
    label: group.name,
    value: {
      name: group.name,
      id: group.id,
      type: 'group'
    }
  }));
};

export default {
  getPermissionGroups,
  getGroups,
  createGroup,
  updateGroup,
  deleteGroup,
  addUserIntoGroup,
  removeUserFromGroup,
  getUsersOfGroup,
  getPermissionsOfGroup,
  setPermissionsOfGroup
};



// WEBPACK FOOTER //
// ./src/api/group/index.js